
import React, { EffectCallback, useEffect } from 'react'
import { SocketContext } from '../contexts/socket';
import Emitter from 'component-emitter'
import { useAuth } from '../contexts/AuthContext';
import { logout_axios } from '../services/auth-service';

// import FastForwardIcon from '@mui/icons-material/FastForward';
// import SignalWifiConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiConnectedNoInternet4';

interface Props {
}

export const LatencyIndicator = function (props: Props) {
    const [avg, setAvg] = React.useState(0)
    let ping_pong_times: number[] = []
    let start_time: number
    const socket = React.useContext(SocketContext);
    const { clearsession, updateRefreshToken } = useAuth()

    useEffect((): any => {
        create_connections()
        return () => socket.off();
    }, [])
    
    const create_connections = React.useCallback(() => {
        window.setInterval(function () {
            start_time = (new Date).getTime();
            socket.emit('ping');
        }, 1000);

        socket.on('pong', function (data: any) {
            if (data.backendmodified == 1) {
                // Trigger frontend reset
                if ( data.initiate == 'refresh' ) {
                    updateRefreshToken();
                } else if ( data.initiate == 'logout' ) {
                    // Trigger Backend Logout Procedure
                    logout_axios()
                    // Clear User Sessoin Procedure.
                    clearsession();
                    window.location.href = "/rti-gui/login"
                }
            }
            var latency = new Date().getTime() - start_time;
            ping_pong_times.push(latency);
            ping_pong_times = ping_pong_times.slice(-30); // keep last 30 samples
            var sum = 0;
            for (var i = 0; i < ping_pong_times.length; i++)
                sum += ping_pong_times[i];
            setAvg(Math.round(10 * sum / ping_pong_times.length) / 10)
        });
    }, [])


    return (
        <div style={{marginLeft: '8px', maxWidth: '1200px'}}>
            <h4>Status:&nbsp;
                { (avg*1 >= 0) ? <span style={{ color:'#5fc262'}}>Connected</span> : <span style={{ color:'#e74c3c'}}>Check Connection</span> }
                </h4>
        </div>
    )
}
